import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BankingService {
  private apiUrl = 'http://localhost:3000/api/plaid'; // Adjust to your backend URL

  constructor(private http: HttpClient) {}

  createLinkToken(): Observable<any> {
    return this.http.post(`${this.apiUrl}/create_link_token`, {});
  }

  exchangePublicToken(public_token: string): Observable<any> {
    console.warn(public_token)
    return this.http.post(`${this.apiUrl}/exchange_public_token`, { public_token });
  }

  getTransactions(access_token: string, start_date?: string, end_date?: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/transactions`, {
      access_token,
      start_date: start_date || '2023-01-01',
      end_date: end_date || '2024-01-01',
    });
  }
}